export default __webpack_public_path__ + "assets/audio/1-50250429_clip.mp3";